import styles from './Efficiency.module.scss';
import {
  Image,
  Card,
  Content,
  CardBody,
  Modal,
  Heading,
  Button,
  FontAwesomeProIcon,
} from '@wienenergiegithub/ui-next';
import React from 'react';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Efficiency = ({ tacho, finalPoints, className }) => {
  const dialog = useDialogStore({ animated: true });

  return (
    <>
      <Card className={classNames(styles.constainer, className)}>
        <CardBody className={styles.body}>
          <Heading as="h3" noSpacing size="h5">
            Ihre Heizungseffizienz
          </Heading>
          <Image alt="" className={styles.tacho} src={tacho} />
          <Content className={styles.points} noSpacing>
            {finalPoints}/100{' '}
            <DialogDisclosure
              aria-label="Berechnung"
              render={
                <Button
                  className={styles.informationButton}
                  shape="bubble"
                  type="button"
                >
                  <FontAwesomeProIcon
                    className={styles.infoIcon}
                    color="primary"
                    icon="info-circle"
                    role="presentation"
                  />
                </Button>
              }
              store={dialog}
            />
          </Content>
        </CardBody>
      </Card>
      <Modal header="Berechnung" store={dialog} theme="default">
        <Content noSpacing>
          Die Berechnung ist eine ungefähre Einschätzung Ihrer Heizungseffizienz
          und basiert auf Ihren Angaben. Sie stellt lediglich einen Richtwert
          dar, der die wichtigsten Faktoren beim Heizen berücksichtigt, aber es
          gibt natürlich auch noch andere.
        </Content>
      </Modal>
    </>
  );
};

Efficiency.propTypes = {
  className: PropTypes.string,
  finalPoints: PropTypes.number,
  tacho: PropTypes.string,
};

export { Efficiency };
